import { Boq } from "../Boq/Boq.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type AllureQuarterlyPlan = {
    id: number;
    project_id: number;
    year: string;
    prepared_by_id: number;
    checked_by_id: number;

    prepared_by: User;
    checked_by: User;
    allure_quarterly_plan_items: AllureQuarterlyPlanItem[];
    allure_quarterly_plan_statuses: AllureQuarterlyPlanStatus[];
    user_id?: number;
    is_draft?: boolean;
};

export type AllureQuarterlyPlanItem = {
    id: number;
    allure_quarterly_plan_id: number;
    boq_id: number;
    quarter_1: number;
    quarter_2: number;
    quarter_3: number;
    quarter_4: number;
    boq: Boq
}

export type AllureQuarterlyPlanStatus = {
    allure_quarterly_plan_id: number;
    type: "View" | "Check" | "Approve";
    status: number;
    assigned_by: number;
    user_id: number;
    id: number;
};

export type AllureQuarterlyPlanStateTypes = {
    fetchAll: ApiCallState<AllureQuarterlyPlan[]>;
    fetchOne: ApiCallState<AllureQuarterlyPlan | {}>;
};

export const AllureQuarterlyPlanActionTypes = {
    FETCH_ALL_ALLURE_QUARTERLY_PLAN: "FETCH_ALL_ALLURE_QUARTERLY_PLAN",
    FETCH_ALL_ALLURE_QUARTERLY_PLAN_RESET: "FETCH_ALL_ALLURE_QUARTERLY_PLAN_RESET",
    FETCH_ALL_ALLURE_QUARTERLY_PLAN_FAILURE: "FETCH_ALL_ALLURE_QUARTERLY_PLAN_FAILURE",
    FETCH_ALL_ALLURE_QUARTERLY_PLAN_SUCCESS: "FETCH_ALL_ALLURE_QUARTERLY_PLAN_SUCCESS",

    FETCH_ONE_ALLURE_QUARTERLY_PLAN: "FETCH_ONE_ALLURE_QUARTERLY_PLAN",
    FETCH_ONE_ALLURE_QUARTERLY_PLAN_RESET: "FETCH_ONE_ALLURE_QUARTERLY_PLAN_RESET",
    FETCH_ONE_ALLURE_QUARTERLY_PLAN_FAILURE: "FETCH_ONE_ALLURE_QUARTERLY_PLAN_FAILURE",
    FETCH_ONE_ALLURE_QUARTERLY_PLAN_SUCCESS: "FETCH_ONE_ALLURE_QUARTERLY_PLAN_SUCCESS",
};
